import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom"; // Import Link from react-router-dom
import { toast } from "react-toastify";
import { deleteApi } from "../../Services/apiService";

const DeleteModal = ({ setDeleteModal, eventDetails, fetchEvents }) => {
  const navigate = useNavigate();
  const closeModal = () => {
    setDeleteModal(true);
  };
  const [loader, setLoader] = useState(false);
  const handleDelete = async () => {
    setLoader(true);
    try {
      // Dynamically construct the API endpoint based on `comp`
      // const endpoint = comp === 'user'
      //     ? `/admin/user/`
      //     : comp === 'meditation'
      //     ? `/admin/meditation/`
      //     : `/admin/default/`; // Add a fallback endpoint if needed
      const response = await deleteApi(`admin/events/${eventDetails?.id}`);

      if (response?.status === 200) {
        setLoader(false);
        setDeleteModal(false);
        fetchEvents();
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };
  return (
    <>
      <div className="detail-page-modal">
        <div className="modal-header">
          <h3> Are you sure you want to delete?</h3>
          {/* <span>
            {" "}
            <img
              src={window.getPublicUrl("/assets/images/del-icon.svg")}
              alt=""
            />
          </span> */}
          {/* <button
            className="close-button"
            onClick={() => setDeleteModal(false)}
          >
            <img
              src={window.getPublicUrl("/assets/images/gray-cross.svg")}
              alt=""
            />
          </button> */}
        </div>
        <div className="modal-body"></div>
        <div className="modal-footer">
          <button className="cancel" onClick={() => setDeleteModal(false)}>
            Cancel
          </button>
          <button
            className="save"
            disabled={loader}
            onClick={() => handleDelete()}
          >
            {loader && (
              <div className="spinner-border" role="status">
                <span className="sr-only"></span>
              </div>
            )}
            Delete
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteModal;
